export const ko = {
  ko: {
    translation: {
      confirm_app_exit: '아기상어 키즈월드를 종료하시겠어요?',
      button_exit: '종료',
      button_cancel: '취소',
      os_update: '최신 TV OS 버전으로 업데이트하고 다시 이용해주세요.',
      button_ok: '확인',
      t_complete_app_update: '아기상어 키즈월드가 업데이트 되었습니다.',
      error_title: '오류가 발생했습니다',
      error_unknown: '앱을 종료하고 다시 실행해보세요.',
      error_network_title: '인터넷 연결이 불안정합니다.',
      error_network: '네트워크 연결 후 이용해 주세요.',
      button_retry: '재시도',
      confirm_continue_watching: '시청 중인 영상입니다.\n이어서 보시겠어요?',
      button_continue_watching: '이어보기',
      button_from_beginning: '처음부터 보기',
      t_event_coming_soon: '이벤트가 준비 중이에요.',
      data_fail: '오류가 발생했습니다.\n앱을 종료하고 다시 실행해보세요.',
      page_sign_in_header: 'QR코드로 로그인하기',
      page_sign_in: '서비스를 이용하려면 로그인이 필요해요.\nQR코드를 스캔해서 로그인해보세요.',
      page_sign_in_code: '확인코드',
      page_sign_in_time: '남은 시간',
      oauth_confirm_code: 'TV의 확인코드와 \n일치하는지 확인해주세요.',
      oauth_web_info: '웹 브라우저',
      oauth_device_info: '디바이스 접속정보',
      oauth_accept_sign_in: '로그인 수락',
      oauth_sign_in_success: '기기 로그인이 완료되었습니다.',
      oauth_sign_in_cancel: '기기 로그인이 취소되었습니다.',
      oauth_sign_in_fail: '오류가 발생했습니다.\nQR코드로 로그인을 다시 시도해주세요.',
      oauth_sign_in_expired: '로그인 시간이 만료되었습니다.\nTV의 QR코드를 다시 스캔해서 \n로그인해보세요.',
      menu_my: 'MY',
      menu_home: '홈',
      menu_story: '동화',
      menu_song: '동요',
      menu_cinema: '극장판',
      menu_cinema_and_tv: '극장판 & TV 시리즈',
      menu_ip: 'IP',
      menu_topics: '토픽',
      menu_home_history: '최근 본 영상',
      title_ai_videos: 'AI 추천 영상',
      menu_home_new_content: '새로 나온 영상',
      player_language_ko: '한국어',
      player_language_en: 'English',
      player_language_zh: '中文',
      player_language_pt: 'Português',
      player_language_es: 'Español',
      player_language_ja: '日本語',
      player_language_id: 'Bahasa Indonesia',
      mypage_menu_status_unsusbcribed: '이용중인 구독권이 없습니다.',
      mypage_menu_status_susbcribed: '핑크퐁플러스 <span class="text-secondary">구독중</span>입니다.',
      mypage_menu_benefits_unsusbcribed: '구독 혜택',
      mypage_menu_benefits_susbcribed: '누리고 있는 혜택',
      mypage_menu_benefits_01: '2만여 편의 오리지널 시리즈 제공',
      mypage_menu_benefits_02: '정기적으로 업데이트되는\n핑크퐁플러스 단독 콘텐츠 제공',
      mypage_menu_benefits_03: '한 번의 구독으로 TV, 모바일 동시 이용',
      mypage_menu_benefits_04: '30+ 종 놀이학습 앱 무제한 이용',
      mypage_scan_to_subscribe: 'QR코드를 스캔해서 구독해보세요',
      mypage_video_title: '핑크퐁플러스란?',
      mypage_menu_terms: '약관',
      mypage_menu_event: '이벤트',
      mypage_menu_support: '고객센터',
      button_sign_out: '로그아웃',
      mypage_menu_event_coming_soon: '진행 예정',
      mypage_menu_even_open: '진행 중',
      terms_required_privacy: '개인정보 수집 및 이용 약관',
      terms_required_pinkfong: '핑크퐁 통합 서비스 이용 약관',
      terms_required_interactive: '핑크퐁 인터랙티브앱 서비스 이용 약관',
      mypage_menu_device_info: '기기정보',
      page_device_info: '아래 정보와 함께 문의하면 문제 해결을 더욱 빠르게 도와드릴 수 있어요.',
      page_device_info_model: '디바이스 모델',
      page_device_info_os: '플랫폼 OS',
      page_device_info_version: '앱 버전 정보',
      page_support: '서비스 이용에 도움이 필요한 경우 \n아래 이메일로 문의하세요.\ncs@pinkfong.com',
      caution_sign_out: '로그아웃하시면\n서비스 이용이 제한됩니다.',
      topic_category_all: 'All',
      player_language_button: '언어',
    },
  },
};
